import { render } from "./material.vue?vue&type=template&id=3481e2d5&scoped=true"
import script from "./material.vue?vue&type=script&lang=js"
export * from "./material.vue?vue&type=script&lang=js"

import "./material.vue?vue&type=style&index=0&id=3481e2d5&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/ssp-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3481e2d5"]])

export default __exports__